<div class="row payment__row">
  <div class="col-12 payment__intro">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('payment_intro')"
        [innerHTML]="translationService.getTranslation('payment_intro')"
        class="payment__intro-title"></h3>
  </div>
  <div class="col-12 payment__description">
    <p [innerHTML]="translationService.getTranslation('payment_description')"
        class="payment__description-title"></p>
  </div>
</div>

<div class="row payment__row">
  <div class="col-12 payment__content">
    @if (isLoadingPayments || isLoadingSubs) {
      <div style="text-align: center;" class="payment__loading">
        <app-loading-spinner/>
      </div>
    } @else {
      @if (errorsArr.length > 0) {
        <app-general-errors [errors]="errorsArr" class="payment__errors"></app-general-errors>
      } @else {
        <div class="row">
          <div class="col-12 col-lg-6">
            <mat-card appearance="outlined" class="mb-3 payment__card">
              <mat-card-title class="m-3 payment__card-title"
                              [innerHTML]="translationService.getTranslation('payment_bankinfos')">
              </mat-card-title>
              <mat-card-content class="payment__card-content">
                @for (payment of payments; track payment) {
                  <div tabindex="0" class="row mb-3 payment__bank-row">
                    <div tabindex="0" class="col-8 payment__bank-info">
                      <div
                        [innerHTML]="translationService.getTranslation('payment_iban') + ': ' + payment.bank.swiftIBAN | bankAccount "
                        class="payment__bank-iban">
                      </div>
                    </div>
                    <div class="col-4 editButtonContainer text-center payment__bank-actions">
                      @if (payment.webId <= 0) {
                        <button mat-raised-button color="primary" (click)="paymentEdit(payment)"
                                [innerHTML]="translationService.getTranslation('button_change')"

                                class="payment__bank-edit-btn"></button>

                      }
                      @else {
                        <fa-icon [icon]="'hourglass'" size="2x" placement="top"
                                 [ngbTooltip]="translationService.getTranslation('payment_existing_change')"
                                 class="payment__bank-hourglass"></fa-icon>
                      }
                    </div>
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
        @if (displayPaymentChange) {
          <div class="col-12 col-lg-6">
            <mat-card appearance="outlined" class="payment__card payment__card--change">
              <mat-card-title class="m-3 payment__card-title"
                              [innerHTML]="translationService.getTranslation('payment_editsub')">
              </mat-card-title>
              <mat-card-content class="payment__card-content">
                @for (sub of subs; track sub) {
                  <div class="row mb-3 payment__sub-row">
                    <div class="col-8 payment__sub-info">
                      <div tabindex="0" class="payment__sub-desc">
                        {{ sub.productDescription }} / {{ sub.variantDescription }}
                        <div [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.backendId"
                             class="payment__sub-orderid">
                        </div>
                      </div>
                    </div>
                    <div class="col-4 editButtonContainer text-center payment__sub-actions">
                      @let onlinePayment = isOnlinePayment(sub.curPayment);
                      @if (sub.curPayment.webId <= 0) {
                        <button mat-raised-button color="primary" (click)="subPaymentEdit(sub)"
                                [innerHTML]="translationService.getTranslation('button_change')"
                                [disabled]="onlinePayment"
                                class="payment__sub-edit-btn"></button>
                      }
                      @if (sub.curPayment.webId > 0) {
                        <fa-icon [icon]="'hourglass'" size="2x" placement="top"
                                 [ngbTooltip]="translationService.getTranslation('payment_existing_change')"
                                 class="payment__sub-hourglass"></fa-icon>
                      }
                    </div>
                    @if (onlinePayment) {
                      <p *appApplyIfNotEmpty="translationService.getTranslation('paymentEdit_impossible')" class="payment-edit__warning text-warning text-end" id="payment-edit-warning"
                         [innerHTML]="translationService.getTranslation('paymentEdit_impossible')"></p>
                    }
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
        }
        </div>
      }
    }
  </div>
</div>
